var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93258 1L1 4.93258L4.93258 8.86517M1.31496 4.93264H12.0116C14.7791 4.93264 17.0453 7.22337 17.0453 9.99093C17.0453 12.7585 14.7791 15.0001 12.0116 15.0001H8.86552",
    stroke: "#5E869D",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateIconLeft);
export default __webpack_public_path__ + "static/media/navigate-icon-left.22234ff5d0a2d898cd13ab8e1afa74c3.svg";
export { ForwardRef as ReactComponent };